import Vue from "vue";
import moment from "moment";

Vue.filter("myGlobal", (created) => {
  if (created) return moment(created).format("DD/MM/YYYY");
  return "-";
});

Vue.filter("myGlobalWithHour", (created) => {
  if (created) return moment(created).format("MM/DD/YYYY h:mm A");
  return "-";
});

Vue.filter("myDateGlobal", (created) => {
  // Set the locale to Spanish
  moment.locale('es');

  // Format the date with the desired format (ddd, D MMM YYYY) and capitalize the first letter of the day
  const formattedDate = moment(created).format("ddd, D MMM YYYY");
  
  // Capitalize the first letter of the day
  const capitalizedDay = formattedDate.replace(/^\w/, (c) => c.toUpperCase());

  return capitalizedDay;
});

Vue.filter("myDateGlobalWithHour", (created) =>
  moment(created).format("ddd, D MMM YYYY hh:mm A")
);

Vue.filter("myTime", (created) => {
  if (created) return moment(created, "HH:mm:ss").format("hh:mm A");
  return "-";
});

Vue.filter("myGlobalDay", (created) => {
  if (created) return moment(created).format("DD/MM/YYYY hh:mm A");
  return "-";
});

Vue.filter("myDate", function (created) {
  return moment(created).format("MMMM Do YYYY");
});
Vue.filter("formatDate", function (created) {
  return moment(created).format("YYYY-MM-DD");
});
Vue.filter("myDateText", function (created) {
  return moment(created).format("dddd, Do");
});

Vue.filter("myMonthYear", function (created) {
  return moment(created).format("MMM YY");
});

Vue.filter("myNumberDay", function (created) {
  return moment(created).format("DD");
});

Vue.filter("myDayMonth", function (created) {
  return moment(created).format("DD/MM");
});

Vue.filter("myDateEs", function (created) {
  return moment(created).format("DD/MM/YYYY");
});

